var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,17.69h0a2.32,2.32,0,0,1-2.3,2.3H13.46v2h4.23A4.3,4.3,0,0,0,22,17.69V13.47H20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.73,3.26a4.31,4.31,0,0,0-3-1.26H13.46V4h4.23A2.32,2.32,0,0,1,20,6.3v4.23h2V6.3A4.31,4.31,0,0,0,20.73,3.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6.3H4A2.32,2.32,0,0,1,6.29,4h4.23V2H6.29A4.3,4.3,0,0,0,2,6.3v4.23H4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29,20a2.3,2.3,0,0,1-2.12-1.41A2.25,2.25,0,0,1,4,17.7V13.47H2v4.22a4.17,4.17,0,0,0,.34,1.68,4.3,4.3,0,0,0,4,2.63h4.23V20Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12a5,5,0,1,0-5,5A5,5,0,0,0,17,12Zm-5,3a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordings);
export default __webpack_public_path__ + "static/media/recordings.f8adaf2160a9c4ad3a1019f94bc6a543.svg";
export { ForwardRef as ReactComponent };